import { z } from "zod";

export const IdType = z.string().uuid();
export const sortQuery = z.enum(["asc", "desc"]).optional();
export const PasswordType = z.string();

export type SortQuery = z.infer<typeof sortQuery>;
